import React from 'react';
import Image from 'next/future/image';
import cn from 'classnames';
import FireIcon from '@/public/icons/collection/fire.svg';

export default function HotDealBadge({
  block = false,
  alwaysCenter = false,
  isPremiumCondition = false,
}: {
  block?: boolean;
  alwaysCenter?: boolean;
  isPremiumCondition?: boolean;
}) {
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full bg-link-red-700 pl-2 pr-3 font-black uppercase text-white',
        {
          'absolute -top-1.5 h-3': !block,
          'relative h-4': block,
          'left-1/2 -translate-x-1/2': alwaysCenter,
          'ml-2 xs:ml-0': alwaysCenter && isPremiumCondition,
        },
      )}
      // eslint-disable-next-line react/forbid-dom-props
      style={{ fontSize: block ? 9 : 7 }}
    >
      Deal
      <div
        // eslint-disable-next-line tailwindcss/enforces-negative-arbitrary-values
        className="absolute -right-[4px] -top-[5px] "
      >
        <Image
          priority
          src={FireIcon}
          className={cn({ 'w-3.5': !block, 'w-4': block })}
          alt="Deal"
        />
      </div>
    </div>
  );
}
